// Touch device check: reads the class set on <html> by the inline script in
// <head> (functions.php, of_touch_class).
export const hasTouch = () => document.documentElement.classList.contains('touchevents');
